export enum EsgDataPointTitle {
  SustainabilityFit = 'SustainabilityFit',
  SustainabilityCategory = 'SustainabilityCategory',
  Sfdr = 'SFDR',
  FundsEsgWam = 'FundsEsgWAM',
  HoldingsCoverage = 'HoldingsCoverage'
}

export type EsgDataPointFields = {
  title: string;
  fullTitle?: string;
  primaryInfo: string;
  secondaryInfo?: string;
  article6Title?: string;
  article8Title?: string;
  article9Title?: string;
  article6Info?: string;
  article8Info?: string;
  article9Info?: string;
};

type ESGDataPointLocalization = {
  [key in EsgDataPointTitle]: EsgDataPointFields;
};

export const ESGDataPointLocalizationKeys: ESGDataPointLocalization = {
  [EsgDataPointTitle.SustainabilityFit]: {
    title: 'sustainabilityFit',
    primaryInfo: 'sustainabilityFitInfo'
  },
  [EsgDataPointTitle.SustainabilityCategory]: {
    title: 'sustainabilityCategory',
    primaryInfo: 'sustainabilityCategoryInfo'
  },
  [EsgDataPointTitle.Sfdr]: {
    title: 'sfdr',
    primaryInfo: 'SfdrInfo',
    fullTitle: 'sfdrFullTitle',
    article6Title: 'article6SfdrTitle',
    article8Title: 'article8SfdrTitle',
    article9Title: 'article9SfdrTitle',
    article6Info: 'article6SfdrTextTitle',
    article8Info: 'article8SfdrTextTitle',
    article9Info: 'article9SfdrTextTitle'
  },
  [EsgDataPointTitle.FundsEsgWam]: {
    title: 'fundsEsgWam',
    primaryInfo: 'fundsEsgWamPrimaryInfo',
    secondaryInfo: 'fundsEsgWamSecondaryInfo'
  },
  [EsgDataPointTitle.HoldingsCoverage]: {
    title: 'holdingsCoverage',
    primaryInfo: 'holdingsCoverageInfo'
  }
};

export const ESGDataPointLocalization: ESGDataPointLocalization = {
  [EsgDataPointTitle.SustainabilityFit]: {
    title: 'Sustainability Fit',
    primaryInfo:
      "Sustainability Fit is a percentile ranking of the portfolio universe based on the alignment between your company's S&P Global ESG criteria values and the observed S&P Global ESG criteria values of investment manager's portfolio of equity holdings."
  },
  [EsgDataPointTitle.SustainabilityCategory]: {
    title: 'Sustainability Category',
    primaryInfo:
      'Sustainability Category is derived from Sustainability Focus card on profiles which indicates what sustainability factors investors may consider relevant to investment decision making. Institution focus is determined by underlying fund data and may not be representative of firm-wide practices.'
  },
  [EsgDataPointTitle.Sfdr]: {
    title: 'SFDR',
    fullTitle: 'Sustainable Finance Disclosure Regulation',
    primaryInfo: '',
    article6Title: 'Article 6',
    article8Title: 'Article 8',
    article9Title: 'Article 9',
    article6Info: 'Funds without a sustainability scope',
    article8Info: 'Funds that promote environmental or social characteristics',
    article9Info: 'Funds that have sustainable investment as their objective'
  },
  [EsgDataPointTitle.FundsEsgWam]: {
    title: 'Fund ESG WAM',
    primaryInfo:
      "The Fund ESG Weighted Average Metric measures the Environmental, Social and Governance (ESG) characteristics of a fund’s underlying holdings. It is calculated as the weighted-average S&P Global ESG score of its constituents' companies, based on value-of-holding.",
    secondaryInfo:
      'The metric is an indicative and for informational purposes only. It is not an opinion on the sustainability and cannot be used for reporting purposes.'
  },
  [EsgDataPointTitle.HoldingsCoverage]: {
    title: 'Holdings Coverage',
    primaryInfo:
      'The percentage of a fund’s eligible holdings with an ESG Score included in the Fund ESG Weighted Average Metric calculation displayed. The lower the coverage, the less representative the Fund ESG WAM may be.'
  }
};
